// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WKlJ","colBig":"styles_colBig__2ISfw","colSmall":"styles_colSmall__DStWZ","shopifyNameWrapper":"styles_shopifyNameWrapper__3BNOJ"};